import React from 'react';

import SimplePageBase from './SimplePageBase';


export default class NotFoundPage extends SimplePageBase {
    renderContent() {
        return <h1>Not found</h1>;
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.jsx